import { Capacitor } from '@capacitor/core'

// Matches the native Firebase bridge. A terminal hand-off is intent, not a completed booking.
const DECISION_TYPES: Record<string, string> = {
  reservation_click: 'reservation',
  card_reserve_tapped: 'reservation',
  phone_call: 'phone',
  card_call_tapped: 'phone',
  directions_click: 'directions',
  card_directions_tapped: 'directions',
}

// This is the existing web stream in public/index.html. Explicit routing avoids the Ads tag.
const MEASUREMENT_ID = 'G-ZNMJ616P8T'
const PARAM_KEYS = [
  'restaurant_id', 'restaurant_alias', 'recommendation_id', 'app_version', 'destination',
]

export function prepareWebRestaurantDecision(
  name: string,
  params: Record<string, unknown>,
): Record<string, string> | undefined {
  try {
    if (
      Capacitor.isNativePlatform() || typeof window === 'undefined' ||
      !['www.resactly.com', 'resactly.com'].includes(window.location.hostname) ||
      !Object.prototype.hasOwnProperty.call(DECISION_TYPES, name)
    ) return undefined

    const eventId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
    const result: Record<string, string> = {
      send_to: MEASUREMENT_ID,
      decision_type: DECISION_TYPES[name],
      source_event: name,
      decision_event_id: eventId,
      measurement_version: 'web_terminal_v1',
    }
    if (typeof params.source === 'string' && params.source) result.method = params.source.slice(0, 100)
    for (const key of PARAM_KEYS) {
      if (typeof params[key] === 'string' && params[key]) {
        result[key] = (params[key] as string).slice(0, 100)
      }
    }
    return result
  } catch {
    // Optional measurement must never prevent the original first-party action.
    return undefined
  }
}

export function emitWebRestaurantDecision(params: Record<string, string>): void {
  try {
    const gtag = (window as any).gtag
    if (typeof gtag === 'function') gtag('event', 'restaurant_decision', params)
  } catch {
    // No retries: duplicate terminal signals would distort intent. First-party delivery is separate.
  }
}
